<template>
  <div class="jbxx">
    <el-row class="bg-white info row-style">
      <el-col :span="4" class="tx">
        <img :src="txSrc" alt="" />
        <div>{{ userInfo.name }}</div>
        <!-- <div>
          <el-button size="mini" @click="didTapToAccountCenter"
            >修改密码</el-button
          >
        </div> -->
        <!-- <div>
          <el-button size="mini" @click="logout">退出登录</el-button>
        </div> -->
      </el-col>

      <el-col :span="20">
        <!-- <el-row class="align-center">
          <el-col :span="20" class="gray font14" v-if="false">
            <span>业务管理部</span>
            <el-divider direction="vertical"></el-divider>
            <span>产品经理</span>
          </el-col>
        </el-row> -->
        <el-row>
          <el-row>
            <el-col :span="8" class="font12">
              <span class="gray">部门：</span>
              <span>{{ userInfo.department }}</span>
            </el-col>
            <el-col :span="8" class="font12">
              <span class="gray">职位：</span>
              <span>{{ userInfo.position }}</span>
            </el-col>
            <el-col :span="8" class="font12">
              <span class="gray">工号：</span>
              <span>{{ userInfo.jobnumber }}</span>
            </el-col>
            <el-col :span="8" class="font12">
              <span class="gray">手机号：</span>
              <span>{{ userInfo.mobile }}</span>
            </el-col>
            <el-col :span="8" class="font12">
              <span class="gray">邮箱：</span> <span>{{ userInfo.email }}</span>
            </el-col>
            <el-col :span="8" class="font12">
              <span class="gray">入职时间：</span>
              {{ userInfo.hiredDate }}<span></span>
            </el-col>
            <!-- <el-col :span="8" class="font12">
              <span class="gray">办公地点：</span> {{ userInfo.workPlace}}<span></span>
            </el-col> -->
            <!-- <el-col :span="8" class="font12"> -->
            <!-- <span class="gray">备注：</span> {{ userInfo.remark
              }}<span></span> -->
            <!-- <el-link type="primary" @click="gogrda" class="font12" :underline="false">个人档案</el-link> -->
            <!-- <span @click="gogrda">个人档案</span> -->
            <!-- </el-col> -->
          </el-row>
        </el-row>
      </el-col>
    </el-row>
    <el-card class="row-style">
      <el-row class="archive ">
        <h4>基础信息</h4>
        <el-col :span="6" class="font12">姓名：{{ archiveinfo?.xm }}</el-col>
        <el-col :span="6" class="font12">性别：{{ archiveinfo?.xb }}</el-col>
        <el-col :span="6" class="font12">年龄：{{ archiveinfo?.nl }}</el-col>
        <el-col :span="6" class="font12">出生日期：{{ archiveinfo?.csrq }}</el-col>
        <el-col :span="6" class="font12">民族：{{ archiveinfo?.mz }}</el-col>
        <el-col :span="6" class="font12">籍贯：{{ archiveinfo?.jg }}</el-col>
        <el-col :span="6" class="font12">政治面貌：{{ archiveinfo?.zzmm }}</el-col>
        <el-col :span="6" class="font12">婚姻状况：{{ archiveinfo?.hyzk }}</el-col>
        <el-col :span="6" class="font12">健康状况：{{ archiveinfo?.jkzk }}</el-col>
        <el-col :span="6" class="font12">体重：{{ archiveinfo?.tz }}</el-col>
        <el-col :span="6" class="font12">身高：{{ archiveinfo?.sg }}</el-col>
        <el-col :span="6" class="font12">子女状况：{{ archiveinfo?.znzk }}</el-col>
        <el-col :span="6" class="font12">身份证号：{{ archiveinfo?.sfzh }}</el-col>
        <el-col :span="6" class="font12">联系电话：{{ archiveinfo?.lxdh }}</el-col>
        <el-col :span="6" class="font12">户口类型：{{ archiveinfo?.hklx }}</el-col>
        <el-col :span="6" class="font12">邮箱：{{ archiveinfo?.yx }}</el-col>
        <el-col :span="6" class="font12">职级：{{ archiveinfo?.zj }}</el-col>
        <el-col :span="6" class="font12">职级评定时间：{{ archiveinfo?.pdsj }}</el-col>
        <el-col :span="12" class="font12">户籍地址：{{ archiveinfo?.hjdz }}</el-col>
        <el-col :span="12" class="font12">现居地址：{{ archiveinfo?.xzz }}</el-col>
        <el-col :span="12" class="font12">特长：{{ archiveinfo?.tc }}</el-col>
        <el-col :span="12" class="font12">爱好：{{ archiveinfo?.ah }}</el-col>
      </el-row>
    </el-card>
    <el-card class="archive row-style">
      <h4>教育背景</h4>
      <avue-crud :data="jyList" :option="jyxxoption"></avue-crud>
    </el-card>
    <el-card class="archive row-style">
      <h4>工作经历</h4>
      <avue-crud :data="gzList" :option="gzxxoption"></avue-crud>
    </el-card>
    <el-card class="archive row-style">
      <h4>家庭情况</h4>
      <avue-crud :data="jtList" :option="jtxxoption"></avue-crud>
    </el-card>
    <el-card class="archive row-style">
      <h4>公司内经历</h4>
      <avue-crud :data="gsnjllist" :option="jsjlxxoption"></avue-crud>
    </el-card>
    <el-card class="archive row-style">
      <h4>参与项目</h4>
      <avue-crud :data="cyxmlist" :option="cyxmoption"></avue-crud>
    </el-card>
    <el-card class="archive row-style">
      <h4>培训经历</h4>
      <avue-crud :data="pxjllist" :option="pxjloption"></avue-crud>
    </el-card>
    <el-card class="archive row-style">
      <h4>奖惩信息</h4>
      <avue-crud :data="jcxxlist" :option="jcxxoption"></avue-crud>
    </el-card>
    <!-- <el-row class="tj row-style">
      <div class="bg-white">
        <h5 class="title">
          统计日报
          <span class="week" :class="{ active: active == 'week' }" @click="clickTime('week')">近一周</span>
          <span class="month" :class="{ active: active == 'month' }" @click="clickTime('month')">近一月</span>
        </h5>
        <div id="week" :style="{ zoom: scale }"></div>
      </div>
      <div class="bg-white">
        <h5 class="title">月度工作量统计</h5>
        <el-row>
          <el-col :span="12" v-for="(item, index) in monthData" :key="index">
            <h6 class="chart-title">{{ item.rq }}</h6>
            <div :id="'month' + index" :style="{ zoom: scale }"></div>
          </el-col>
        </el-row>
      </div>
      </el-row>
      <el-row class="row-style bg-white table">
        <h5 class="title">行政流程申请</h5>
        <avue-crud ref="avueCrud" :data="tableData" :option="option" v-model="form" :table-loading="TABLE_LOADING"
          :page.sync="TABLE_PAGE" @search-change="SEARCH_CHANGE" @refresh-change="TABLE_REFRESH"
          @search-reset="SEARCH_RESET" @cell-click="CELL_CLICK" @selection-change="SELECTION_CHANGE"
          @sort-change="SORT_CHANGE" @size-change="SIZE_CHANGE" @current-change="CURRENT_CHANGE"
          :before-open="beforeOpen" :before-close="beforeClose" @row-update="rowUpdate" @row-save="rowSave"
          @row-del="rowDel">
          <template slot-scope="{ type, size, row }" slot="menu">
            <el-button icon="el-icon-view" :size="size" :type="type" @click="doToDo(row)">办理</el-button>
          </template>
        </avue-crud>
      </el-row> -->
    <div style="text-align: -webkit-center;">
      <el-button type="primary" size="small" @click="edit()">编辑</el-button>
    </div>

    <!-- <el-row class="tj row-style">
      <div class="bg-white">
        <h5 class="title">
          统计日报
          <span
            class="week"
            :class="{ active: active == 'week' }"
            @click="clickTime('week')"
            >近一周</span
          >
          <span
            class="month"
            :class="{ active: active == 'month' }"
            @click="clickTime('month')"
            >近一月</span
          >
        </h5>
        <div id="week" :style="{ zoom: scale }"></div>
      </div>
      <div class="bg-white">
        <h5 class="title">月度工作量统计</h5>
        <el-row>
          <el-col :span="12" v-for="(item, index) in monthData" :key="index">
            <h6 class="chart-title">{{ item.rq }}</h6>
            <div :id="'month' + index" :style="{ zoom: scale }"></div>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <el-row class="row-style bg-white table">
      <h5 class="title">行政流程申请</h5>
      <avue-crud
        ref="avueCrud"
        :data="tableData"
        :option="option"
        v-model="form"
        :table-loading="TABLE_LOADING"
        :page.sync="TABLE_PAGE"
        @search-change="SEARCH_CHANGE"
        @refresh-change="TABLE_REFRESH"
        @search-reset="SEARCH_RESET"
        @cell-click="CELL_CLICK"
        @selection-change="SELECTION_CHANGE"
        @sort-change="SORT_CHANGE"
        @size-change="SIZE_CHANGE"
        @current-change="CURRENT_CHANGE"
        :before-open="beforeOpen"
        :before-close="beforeClose"
        @row-update="rowUpdate"
        @row-save="rowSave"
        @row-del="rowDel"
      >
        <template slot-scope="{ type, size, row }" slot="menu">
          <el-button
            icon="el-icon-view"
            :size="size"
            :type="type"
            @click="doToDo(row)"
            >办理</el-button
          >
        </template>
      </avue-crud>
    </el-row> -->
  </div>
</template>

<script>

import { dateFormat } from '@/framework/util/date.js'
export default {
  // mixins: [crudPageMinix],
  data() {
    // const stamp = 86400000
    return {
      // tableData: [],
      // monthData: [],
      jyList: [],
      gzList: [],
      jtList: [],
      gsnjllist: [],
      cyxmlist: [],
      pxjllist: [],
      jcxxlist: [],
      archiveinfo: {},
      userInfo: {},
      jyxxoption: {
        addBtn: false,
        editBtn: false,
        delBtn: false,
        header: false,
        viewBtn: true,
        menuWidth: 80,
        border: true,
        size: 'small',
        column: [
          {
            label: '起止时间',
            prop: 'qzsj'
          },
          {
            label: '学校名称/培训单位',
            prop: 'xxmc',
            labelWidth: 140
          },
          {
            label: '地区',
            prop: 'dq'
          },
          {
            label: '专业/培训内容',
            prop: 'zy',
            labelWidth: 140
          },
          {
            label: '所获证书',
            prop: 'shzs'
          }
        ]
      },
      gzxxoption: {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        header: false,
        viewBtn: true,
        menuWidth: 80,
        border: true,
        column: [
          {
            label: '起止时间',
            prop: 'qzsj'
          },
          {
            label: '公司名称',
            prop: 'gsmc',
            overHidden: true
          },
          {
            label: '职位',
            prop: 'zw',
            overHidden: true
          },
          {
            label: '岗责',
            prop: 'gz',
            overHidden: true
          },
          {
            label: '证明人',
            prop: 'zmr'
          },
          {
            label: '联系电话',
            prop: 'lxdh',
            label: '联系电话'
          },

          {
            label: '离职原因',
            prop: 'lzyy',
            overHidden: true
          },
          {
            label: '公司奖惩情况',
            prop: 'gsjcqk',
            overHidden: true,
            labelWidth: 120
          },
          {
            label: '负责任务简介',
            prop: 'sfzyrwjj',
            overHidden: true,
            labelWidth: 120
          }
        ]
      },
      jtxxoption: {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        header: false,
        viewBtn: true,
        menuWidth: 80,
        border: true,
        column: [
          {
            label: '姓名',
            prop: 'xm'
          },
          {
            label: '关系',
            prop: 'gx'
          },
          {
            label: '年龄',
            prop: 'nl'
          },
          {
            label: '工作单位',
            prop: 'gzdw',
            overHidden: true
          },
          {
            label: '职位',
            prop: 'zw'
          },
          {
            label: '电话',
            prop: 'dh'
          }
        ]
      },
      jsjlxxoption: {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        header: false,
        viewBtn: true,
        menuWidth: 80,
        border: true,
        column: [
          {
            label: '起止时间',
            prop: 'gsnjl_qzrq',
            type: 'date'
          },
          {
            label: '所属部门',
            prop: 'gsnjl_ssbm'
          },
          {
            label: '部门变动',
            prop: 'gsnjl_bmbd',
            overHidden: true
          },
          {
            label: '职位',
            prop: 'gsnjl_zw1',
            overHidden: true
          },
          {
            label: '岗位等级',
            prop: 'gsnjl_gwdj'
          },
          {
            label: '职务',
            prop: 'gsnjl_zw'
          }
        ]
      },
      cyxmoption: {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        header: false,
        viewBtn: true,
        menuWidth: 80,
        border: true,
        column: [
          {
            label: '项目名称',
            prop: 'cyxm_xmmc',
            overHidden: true
          },
          {
            label: '项目编号',
            prop: 'cyxm_xmbh'
          },
          {
            label: '项目开始时间',
            prop: 'cyxm_xmkssj',
            type: 'date',
            labelWidth: 100
          },
          {
            label: '项目结束时间',
            prop: 'cyxm_xmjssj',
            type: 'date',
            labelWidth: 100
          },
          {
            label: '参与角色',
            prop: 'cyxm_cyjs'
          },
          {
            label: '参与时间',
            prop: 'cyxm_cysj',
            type: 'date',
            overHidden: true,
            labelWidth: 100
          },
          {
            label: '工作量',
            prop: 'cyxm_gzl'
          },
          {
            label: '项目进展',
            prop: 'cyxm_xmjz',
            overHidden: true
          },
          {
            label: '参与程度',
            prop: 'cyxm_cycd',
            overHidden: true
          }
        ]
      },
      pxjloption: {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        header: false,
        viewBtn: true,
        menuWidth: 80,
        border: true,
        column: [
          {
            label: '培训名称',
            prop: 'pxjl_pxmc'
          },
          {
            label: '培训类型',
            prop: 'pxlx'
          },
          {
            label: '培训机构',
            prop: 'pxjl_pxjg',
            overHidden: true
          },
          {
            label: '培训地点',
            prop: 'pxjl_pxdd'
          },
          {
            label: '培训日期',
            prop: 'pxjl_pxrq',
            overHidden: true
          },
          {
            label: '培训内容',
            prop: 'pxjl_pxnr',
            overHidden: true
          },
          {
            label: '培训费用',
            prop: 'pxjl_pxfy'
          },
          {
            label: '培训证书',
            prop: 'pxjl_pxzs'
          }
        ]
      },
      jcxxoption: {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        header: false,
        viewBtn: true,
        menuWidth: 80,
        border: true,
        column: [
          {
            label: '奖惩信息',
            prop: 'jcxx_jcxx',
            overHidden: true
          },
          {
            label: '奖惩日期',
            prop: 'jcxx_jcrq'
          },
          {
            label: '奖惩级别',
            prop: 'jcxx_jcjb'
          },
          {
            label: '奖惩依据',
            prop: 'jcxx_jcyj',
            overHidden: true
          },
          {
            label: '奖惩决策人',
            prop: 'jcxx_jcjcr'
          },
          {
            label: '奖惩影响',
            prop: 'jcxx_jcyx',
            overHidden: true
          }
        ]
      }
    }
  },
  mounted() {
    const loginName = this.$store.getters.userInfo.subject.loginName
    this.getPersonalCenter()
    this.getarchiveinfo(loginName)
    this.getjyList(loginName)
    this.getgzList(loginName)
    this.getjtList(loginName)
    this.getgsnjllist(loginName)
    this.getcyxmlist(loginName)
    this.getpxjllist(loginName)
    this.getjcxxlist(loginName)
  },
  methods: {
    // 获取教育经历
    getjyList(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1703210870609?loginName=' + e).then((res) => {
        this.jyList = res.data
      })
    },
    // 获取工作经历
    getgzList(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1703211143200?loginName=' + e).then((res) => {
        this.gzList = res.data
      })
    },
    // 获取家庭情况
    getjtList(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1703210992467?loginName=' + e).then((res) => {
        this.jtList = res.data
      })
    },
    // 获取公司内经历
    getgsnjllist(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1703211658102?loginName=' + e).then((res) => {
        this.gsnjllist = res.data
      })
    },
    // 获取参与项目
    getcyxmlist(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1703211515055?loginName=' + e).then((res) => {
        this.cyxmlist = res.data
      })
    },
    // 获取培训经历
    getpxjllist(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1703213864368?loginName=' + e).then((res) => {
        this.pxjllist = res.data
      })
    },
    // 获取奖惩信息
    getjcxxlist(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1703213670671?loginName=' + e).then((res) => {
        this.jcxxlist = res.data
      })
    },
    // 获取档案信息
    getarchiveinfo(e) {
      this.$http.post('fighter-apis-manage/apis/query/apis-1702972877743?loginName=' + e).then((res) => {
        // res.data[0]?.sfzh.replace(/(.{6}).*(.{4})/, '$1********$2') || ''
        this.archiveinfo = res.data[0]
      })
    },
    // 获取账号信息
    getPersonalCenter() {
      this.$http
        .get('/personalCenter/getPersonalCenter')
        .then((res) => {
          if (
            res.data.subject.accountDetail &&
            res.data.subject.accountDetail.extendInfo
          ) {
            let userInfo = JSON.parse(
              res.data.subject.accountDetail.extendInfo
            )
            userInfo.hiredDate = dateFormat(
              new Date(userInfo.hiredDate),
              'yyyy-MM-dd'
            )
            this.userInfo = userInfo
            this.txSrc = res.data.subject.avatar || userInfo.avatar || '/base/images/index/tx.png'
          }
          if (res.data.subject.orgList.length) {
            this.userInfo.department = res.data.subject.orgList[0].name
          }
        })
        .catch((error) => {
          this.$message.error(error.msg || error.message)
        })
    },
    // 跳转个人档案
    gogrda() {
      this.$http.get('/grdalc/getNewDataId').then(res => {
        if (res.data.isThereAnyData === true) {
          this.$router.push({ path: '/' + res.data.url })
        } else {
          this.$message.error('暂未填写档案，请前往服务大厅-员工档案中填写')
        }
      })
    },
    edit() {
      // this.$router.push('/applyForm?businessKey=&formId=e6a103f6697849b99e29118a85478324&pageKey=DO&showNav=no&isIframe=true&isHiddenBtn=1')
      window.open('#/applyForm?businessKey=&formId=e6a103f6697849b99e29118a85478324&pageKey=DO&showNav=no&isIframe=true&isHiddenBtn=1')
    }
  }

}
</script>

<style lang="scss" scoped>
.jbxx {
  padding-left: 10px;

  .info {
    padding: 30px 0 0 0;

    .tx {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        margin-bottom: 10px;
      }

      div {
        margin-bottom: 10px;
      }
    }
  }

  .archive {
    h4 {
      margin: 0;
      padding-bottom: 10px;
    }

    ::v-deep(.avue-crud__pagination) {
      display: none;
    }
  }

  // .tj {
  //   display: flex;
  //   height: 320px;
  //   overflow: hidden;

  //   & > div {
  //     flex: 1;

  //     &:first-child {
  //       margin-right: 10px;
  //     }
  //   }
  // }

  // .table {
  //   .sq-title {
  //     font-size: 14px;
  //     color: #333;
  //     margin: 10px 20px;
  //   }
  // }
}

:deep(.th-style) {
  color: #333 !important;
}

.row-style {
  margin-bottom: 10px;
  // padding: 20px 0;
  // padding-top: 20px;
}

.bg-white {
  background-color: #fff;
}

.gray {
  color: #999;
}

.font14 {
  font-size: 14px;
}

.font12 {
  font-size: 12px;
  padding-bottom: 10px;
}

.align-center {
  display: flex;
  align-items: center;
}

.justify-center {
  display: flex;
  justify-content: center;
}

.title {
  font-size: 16px;
  color: #333;
  margin: 10px 20px;
}

.week,
.month {
  font-size: 12px;
  color: #666;
  cursor: pointer;
}

.week {
  margin-left: 100px;

  &.active {
    color: #000;
    font-size: 14px;
  }
}

.month {
  margin-left: 50px;

  &.active {
    color: #000;
    font-size: 14px;
  }
}

.chart-title {
  text-align: center;
  margin: 10px 0 0 0;
  font-size: 16px;
}
</style>
